<template>
  <div class="w-full justify-end flex pb-3 pr-4">
    <template v-for="button in buttons">
      <button
        :key="button.name"
        v-on:click="submitButton(button)"
        class="inline-flex items-center px-3 py-2 mx-1 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        :disabled="disabled">
        {{button.name}}
      </button>
    </template>
  </div>
</template>
<script>
export default {
  name: 'detention-buttons',
  props: {
    detention: {
      type:Object
    },
    buttons: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submitButton(button){
      const detentionData = {
        id: this.detention.id,
        start: this.detention.start,
        end: this.detention.end,
        diff: this.detention.diff,
        form: button.code,
      }
      this.$store.commit('setState', detentionData)
      this.$router.push('/form/' + button.blueprintid + "/0")
      this.$router.go()
    }
  },
  data() {
    return {}
  }
}
</script>
